import '../css/style.css';
import '../css/animate.css';
import '../css/popup.css'
import '../css/parallaxgallery.css'
import logoB from '../images/logoB.png'
import React, { useEffect, useState, useRef} from 'react'
import { Link, Route, Routes, useLocation } from 'react-router-dom';
import { catalogos } from '../listCatalogos';
import PopUp from './PopUp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faDownload } from '@fortawesome/free-solid-svg-icons'
import Cookies from 'js-cookie';
import Homepage from './Homepage';
import PoliCookies from './PoliCookies';
import Contactos from './Contactos';
import PoliPriva from './PoliPriva';
import { useTranslation } from 'react-i18next';
import { HashLink } from 'react-router-hash-link';
export default function Navbar() {
  const { t, i18n } = useTranslation();
  const [selectedLang, setSelectedLang] = useState(null);

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const handleOpenPopup = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

const location = useLocation();
  const isHomePage = location.pathname === '/';

  // Opção 1: Usando estilos inline
  const navbarStyle = {
    backgroundColor: isHomePage ? 'transparent' : '#f36e26' // Exemplo: transparente na home, cinza escuro nas outras
  };

  // Opção 2: Usando classes CSS
  const navbarClass = isHomePage ? 'navbar-transparent' : 'navbar-solid';

  return (
   <>
       <PopUp isOpen={isPopupOpen} onClose={handleClosePopup}>
         <h2>{t('navbar.catalogos')}</h2>
         <div id="gallery" className="photos-grid-container gallery">
             <div className="sub">
               {catalogos.map((item, index) =>((
                 <a href={item.download} download key={index} className='img-box' target='_blank'>
                   <img loading="lazy" src={item.linkImg} alt="image" />
                   <div className="item__details"> 
                     <div className="item__details_text">
                       {item.nameImg[i18n.language]} <FontAwesomeIcon icon={faDownload} />
                     </div>
                   </div>
                 </a>
               )
             ))} 
           </div>
         </div>
       </PopUp>
   
       <nav className="navbar navbar-dark navbar-expand-lg ftco_navbar ftco-navbar-light" id="ftco-navbar" style={navbarStyle}>
           <div className="container">
           <Link to="/" className="navbar-brand"> <img className='logo' src={logoB} /> </Link>
           <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#ftco-nav" aria-controls="ftco-nav"  aria-expanded={false} aria-label="Toggle navigation" >
               <span className="navbar-toggler-icon"></span>
           </button>
   
           <div className="collapse navbar-collapse" id="ftco-nav">
               <ul className="navbar-nav ms-auto">
               <li className="nav-item"> 
              <HashLink smooth to="/#sobrenos" className="nav-link">
               {t('navbar.sobreN')} 
              </HashLink> </li>
               <li className="nav-item">
              <HashLink smooth to="/#listServices" className="nav-link">
                {t('navbar.services')}
              </HashLink>
               </li>
               <li className="nav-item">
              <HashLink smooth to="/#areas" className="nav-link">
                  {t('navbar.areas')}
              </HashLink>
               </li>
               <li className="nav-item">
                   <button onClick={handleOpenPopup} className="nav-link"> {t('navbar.down')} </button >
               </li>
               <li className="nav-item">
                   <a href="/Contactos" className="nav-link">{t('navbar.contactos')}</a>
               </li>
               </ul>
           </div>
           </div>
       </nav> 
   {/*    <!-- END nav --> */}
      <Routes>
        <Route path='/' element={<Homepage/>}/>
        <Route path='/Contactos' element={<Contactos/>}/>
        <Route path='/politica-de-privacidade/' element={<PoliPriva/>}/>
        <Route path='/politica-de-cookies/' element={<PoliCookies/>}/>
    </Routes>
   </>
  )
}
